import axios from "axios"
const remote = "https://emotion-recognition-with-cnn.herokuapp.com"
const instance = axios.create({
    baseURL: remote
})
export default instance
